// ##### 25-02-05 Komarov
import { Alert } from 'antd';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

// ##### Komarov 2025-07-14
const CaptchaInput = props => {
  return (
    <>
      <ReCAPTCHA
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE}
        ref={props.captchaRef}
      />
      {/* ##### 23-10-24 Komarov: TODO: взять перевод из Смарта */}
      {props.captchaNotSolved && (
        <Alert variant={'danger'}>Please solve a CAPTCHA!</Alert>
      )}
    </>
  );
};

// ##### 25-05-21 Komarov
export default CaptchaInput;
